document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('[data-modal-trigger="loginModal"]');
    if (!trigger) return;
    var loginModal = document.getElementById('loginModal');
    if (!loginModal) return;
    if (trigger.dataset.subscribeAfterLogin === '1') {
        loginModal.dataset.pendingSubscribe = '1';
    } else {
        delete loginModal.dataset.pendingSubscribe;
    }
});

document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-writer-login-form') || !window.WP) return;

    e.preventDefault();
    var emailEl = form.querySelector('input[name="email"]');
    var pwEl    = form.querySelector('input[name="password"]');
    var crsfEl  = form.querySelector('input[name="crsf"]');
    var msgBox  = form.querySelector('.js-writer-login-message');
    var submit  = form.querySelector('button[type="submit"]');
    if (!emailEl || !pwEl || !msgBox || !submit) return;

    msgBox.textContent = '';
    msgBox.className = 'js-writer-login-message';
    form.querySelectorAll('.old-form-error').forEach(function (s) { s.textContent = ''; });
    form.querySelectorAll('.old-form-group.has-error').forEach(function (g) { g.classList.remove('has-error'); });

    submit.disabled = true;
    var fd = new FormData();
    fd.append('email', emailEl.value);
    fd.append('password', pwEl.value);
    if (crsfEl) { fd.append('crsf', crsfEl.value); }

    var loginModal = document.getElementById('loginModal');
    var shouldSubscribe = !!(loginModal && loginModal.dataset.pendingSubscribe === '1');

    fetch(WP.BASE + '/ajax_login', { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
            submit.disabled = false;
            var data = null;
            try { data = JSON.parse(txt); } catch (err) { data = null; }

            // A CRSF token egyszer használatos (a szerver minden JSON válaszban újat küld) —
            // enélkül a második próbálkozás mindig elhasalna a checkPost-on.
            if (data && data.crsf && crsfEl) { crsfEl.value = data.crsf; }

            if (data && !data.errors && data.redir) {
                // DON-530 2a SSO: saját domainen a login után az apexen is be kell
                // jelentkezni ("bárhol lép be, a donably.com-on is belépve legyen").
                // A szerver ssoRedirect-et ad (apex /_sso?_sb=token); odanavigálunk
                // a jelenlegi oldallal mint &back — az apex bejelentkeztet, majd
                // visszahoz ide, immár a saját domainen is + az apexen is belépve.
                var afterLogin = function () {
                    if (data.ssoRedirect) {
                        window.location.href = data.ssoRedirect + '&back=' + encodeURIComponent(window.location.href);
                    } else {
                        window.location.reload();
                    }
                };
                if (!shouldSubscribe) {
                    afterLogin();
                    return;
                }
                var fdSub = new FormData();
                fdSub.append('channelurl', form.dataset.channelurl || WP.body.dataset.channelurl || '');
                fetch(WP.BASE + '/ajax_writerpublic_subscribe', {
                    method: 'POST',
                    body: fdSub,
                    credentials: 'same-origin'
                }).then(function (r) { return r.text(); }).then(function (subTxt) {
                    var subData = null;
                    try { subData = JSON.parse(subTxt); } catch (err) { subData = null; }
                    if (data.ssoRedirect) {
                        // a feliratkozás megtörtént same-originban; az SSO round-trip
                        // után a back oldal friss adatot mutat (feliratkozva)
                        afterLogin();
                    } else if (subData && subData.success && !subData.already) {
                        var sep = window.location.search ? '&' : '?';
                        window.location.href = window.location.pathname + window.location.search + sep + 'subscribed=1';
                    } else {
                        window.location.reload();
                    }
                }).catch(function () {
                    afterLogin();
                });
            } else if (data && data.errors) {
                Object.keys(data.errors).forEach(function (key) {
                    var el = form.querySelector('.' + key);
                    if (el) {
                        el.textContent = data.errors[key];
                        // Az .old-form-error alapból display:none — csak .has-error groupban látszik
                        var group = el.closest('.old-form-group');
                        if (group) { group.classList.add('has-error'); }
                    } else {
                        msgBox.textContent = data.errors[key];
                        msgBox.classList.add('is-error');
                    }
                });
            } else {
                msgBox.textContent = WP.L.ERR_LOGIN;
                msgBox.classList.add('is-error');
            }
        })
        .catch(function () {
            submit.disabled = false;
            msgBox.textContent = WP.L.ERR_NETWORK;
            msgBox.classList.add('is-error');
        });
});
